<template>
  <Card>
    <Form ref="queryForm" :model="queryParams" inline :label-width="80">
      <FormItem label="期望岗位" prop="jobId">
        <Select v-model="queryParams.jobId" clearable style="width: 200px">
          <Option v-for="item in jobs" :value="item.id" :key="item.id">{{ item.title }}</Option>
        </Select>
      </FormItem>
      <FormItem label="性别" prop="sex">
        <Select v-model="queryParams.sex" clearable style="width: 200px">
          <Option value="男">男</Option>
          <Option value="女">女</Option>
        </Select>
      </FormItem>
      <FormItem label="年龄">
        <Input-number v-model="queryParams.ageMin"></Input-number>
        至
        <Input-number v-model="queryParams.ageMax"></Input-number>
      </FormItem>
      <FormItem label="学历" prop="degree">
        <Select v-model="queryParams.degree" multiple clearable style="width: 200px">
          <Option v-for="item in degrees" :value="item.label" :key="item.value">{{ item.label }}</Option>
        </Select>
      </FormItem>
      <!-- <FormItem label="专业" prop="major">
        <Select v-model="queryParams.major" multiple clearable style="width: 200px">
          <Option v-for="item in degrees" :value="item.label" :key="item.value">{{ item.label }}</Option>
        </Select>
      </FormItem> -->
      <FormItem label="工作经验" prop="workYear">
        <Select clearable style="width: 200px" @on-change="changeWorkYear" v-model="queryParams.workYear">
          <Option v-for="item in years" :value="item.label" :key="item.label">{{ item.label }}</Option>
        </Select>
      </FormItem>
      <!-- <FormItem label="求职状态">
        <Select clearable style="width: 200px">
          <Option v-for="item in years" :value="item.label" :key="item.label">{{ item.label }}</Option>
        </Select>
      </FormItem>
      <FormItem label="期望薪资">
        <Input-number v-model="queryParams.ageMin"></Input-number>
        至
        <Input-number v-model="queryParams.ageMax"></Input-number>
      </FormItem>
      <FormItem label="结算方式">
        <Select clearable style="width: 200px">
          <Option v-for="item in years" :value="item.label" :key="item.label">{{ item.label }}</Option>
        </Select>
      </FormItem> -->
      <FormItem style="float: right; margin-right: 0">
        <Button type="primary" @click="getList()" style="margin-right: 10px">搜索</Button>
        <Button @click="resetQueryForm">重置</Button>
      </FormItem>
    </Form>
    <!-- <ButtonGroup style="margin-bottom: 20px">
      <Button
        v-for="(item, index) in statusList"
        :key="index"
        :type="index === statusIdx ? 'primary' : 'default'"
        @click="changeStatus(index)"
      >
        {{ item }}
      </Button>
    </ButtonGroup> -->
    <Table :columns="column" :data="list" style="width: 100%;">
      <template slot-scope="{ row }" slot="name">
        {{ row.resume.name }}
      </template>
      <template slot-scope="{ row }" slot="sex">
        {{ row.resume.sex }}
      </template>
      <template slot-scope="{ row }" slot="age">
        {{ row.resume.age }}
      </template>
      <template slot-scope="{ row }" slot="degree">
        {{ row.resume.degree }}
      </template>
      <template slot-scope="{ row }" slot="major">
        {{ row.resume.major }}
      </template>
      <template slot-scope="{ row }" slot="workYears">
        {{ row.resume.workYearsString }}
      </template>
      <template slot-scope="{ row }" slot="workStatus">
        {{ row.resume.workStatus }}
      </template>
      <template slot-scope="{ row }" slot="jobName">
        {{ row.job.title }}
      </template>
      <template slot-scope="{ row }" slot="expectation">
        <Row :gutter="20" type="flex" v-for="(item, index) in row.resume.expectations" :key="index">
          <Col>
            <span class="expectation-title">{{ item.position }}</span>
          </Col>
          <Col>
            <span class="expectation-content">{{ item.city }}</span>
          </Col>
          <Col>
            <span class="expectation-content" >
              {{ item.salaryString }}
            </span>
          </Col>
        </Row>
      </template>
      <template slot-scope="{ row }" slot="createdAt">
        <div>{{ row.createdAt | dateFormat }}</div>
      </template>
      <template slot-scope="{ row }" slot="action">
        <div>
          <a class="action" @click="showResume(row)" v-if="row.resume">查看简历</a>
          <a class="action" @click="sayHi(row.talentUserId, row.jobId)">打招呼</a>
          <a class="action" @click="del(row.id)">移出人才库</a>
        </div>
      </template>
    </Table>
    <Page
      v-if="pagination.count"
      style="padding: 10px; background: #fff"
      class="page"
      @on-change="changePage"
      :current="pagination.pageIndex"
      :total="pagination.count"
      :page-size="pagination.pageSize"
      size="small"
      show-elevator
    />

    <Modal class="interview-modal" title="邀请参加面试" v-model="showInterviewModal" :closable="false" footer-hide>
      <inter-view @sent="sent" @cancle="cancle" :info="info"></inter-view>
    </Modal>
    <Modal v-model="showResumeModal" :width="700" :footer-hide="true" title="查看简历">
      <resume
        :info="info.resume"
        :fileId="info.fileId"
        :fileName="info.fileName"
        @remove="del"
        :company-talent-id="currentId"
        @invite="yuyue"
      ></resume>
    </Modal>
  </Card>
</template>

<script>
import { getDate, downloadFile } from '@/libs/index';
import interView from '@/components/interview/interview';
import { mapState } from 'vuex';
import resumeaction from '@/view/components/resumemixin';
import resume from '@/view/components/resume';
import { TUIStore, StoreName, TUIConversationService, TUIChatService } from '@tencentcloud/chat-uikit-engine';

export default {
  mixins: [resumeaction],
  data() {
    return {
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        idOrder: 'desc',
        ageMin: null,
        ageMax: null,
        sex: '',
        workYear: '',
        degree: []
      },
      currentId: 0,
      list: [],
      // value: '',
      id: '',
      pagination: {},
      showInterviewModal: false,
      form: {},
      jobId: this.$route.query.jobId,
      showResumeModal: false,
      info: { resume: {} },
      degrees: [],
      jobs: [],
      years: [
        { label: '1年以内', min: 0, max: 1 },
        { label: '1-3年', min: 1, max: 3 },
        { label: '3-5年', min: 3, max: 5 },
        { label: '5-10年', min: 5, max: 10 },
        { label: '10年以上', min: 10, max: 0 }
      ],
      column: [
        { title: '序号', type: 'index', width: 200, align: 'center' },
        // { title: '期望岗位', slot: 'jobName', width: 200 },
        { title: '姓名', slot: 'name', width: 100 },
        { title: '性别', slot: 'sex', width: 80 },
        { title: '年龄', slot: 'age', width: 80 },
        { title: '学历', slot: 'degree', width: 120 },
        { title: '专业', slot: 'major', width: 120 },
        { title: '工作经验', slot: 'workYears', width: 120 },
        { title: '求职状态', slot: 'workStatus', width: 120 },
        { title: '求职意向', slot: 'expectation', width: 340 },
        { title: '添加时间', slot: 'createdAt', width: 120 },
        {
          title: '操作',
          minWidth: 250,
          fixed: 'right',
          slot: 'action'
        }
      ],
      statusList: ['全部', '沟通中', '已面试', '未录取', '已录取'],
      statusIdx: 0,
      provinces: []
    };
  },
  components: {
    interView,
    resume
  },
  computed: {
    ...mapState({
      userProfile: state => state.user.userProfile,
      timPrefix: state => state.user.timPrefix
    })
  },
  mounted() {
    if (this.$route.query.jobId) {
      this.queryParams.jobId = parseInt(this.$route.query.jobId);
    }
    this.getList();
    this.getDegree();
    this.getPositionList();
    this.getProvinces();
  },
  methods: {
    getPositionList() {
      this.$axios
        .request({
          url: 'front/v1/job',
          params: {
            pageSize: 100,
            idOrder: 'desc',
            status: 2
          }
        })
        .then(res => {
          this.jobs = res.data.list;
        });
    },
    changeWorkYear(val) {
      if (!val) {
        this.$set(this.queryParams, 'workYearMin', undefined);
        this.$set(this.queryParams, 'workYearMax', undefined);
        return;
      }
      this.years.forEach(item => {
        if (item.label === val) {
          this.$set(this.queryParams, 'workYearMin', item.min);
          this.$set(this.queryParams, 'workYearMax', item.max);
        }
      });
    },
    getDegree() {
      this.getDicts('degree').then(res => {
        this.degrees = [];
        res.data.forEach(element => {
          element.value = parseInt(element.value);
          this.degrees.push(element);
        });
        if (this.degrees.length >= 1) {
          this.degrees.splice(0, 1);
        }
      });
    },
    resetQueryForm() {
      this.$refs.queryForm.resetFields();
      this.queryParams.ageMin = null;
      this.queryParams.ageMax = null;
      this.queryParams.workYearMin = undefined;
      this.queryParams.workYearMax = undefined;
      this.getList();
    },

    showResume(item) {
      this.showResumeModal = true;
      this.info = item;
      this.currentId = item.id;
      this.$axios
        .request({
          url: 'front/v1/company-resume/read',
          method: 'post',
          data: {
            id: item.resumeId,
            from: '人才库'
          }
        })
        .then(res => {});
    },
    sent() {
      this.showResumeModal = false;
      this.showInterviewModal = false;
    },
    yuyue() {
      this.showInterviewModal = true;
    },
    getList(page = 1) {
      this.queryParams.pageIndex = page;
      let data = { ...this.queryParams };
      delete data.workYear;
      this.$axios.request({ url: 'front/v1/company-talent', method: 'get', params: data }).then(res => {
        this.list = res.data.list;
        this.pagination = { count: res.data.count, pageIndex: res.data.pageIndex, pageSize: res.data.pageSize };
      });
    },
    changePage(page) {
      this.getList(page);
    },
    setStatus(status, item) {
      this.$axios
        .request({
          url: 'api/qiye/companyResume/operation',
          method: 'post',
          data: { id: item.id, status: status }
        })
        .then(res => {
          item.status = status;
          this.$Message.success('已通知对方');
        });
    },
    del(id) {
      this.$Modal.confirm({
        title: '确定',
        content: '<p>确认删除该简历</p>',
        onOk: () => {
          this.$axios
            .request({
              url: 'front/v1/company-talent',
              data: {
                ids: [id]
              },
              method: 'delete'
            })
            .then(res => {
              this.showResumeModal = false;
              this.getList();
            });
        },
        onCancel: () => {}
      });
    },
    changeStatus(index) {
      this.statusIdx = index;
      // TODO 切换类型
    },
    getProvinces() {
      this.$axios
        .request({
          url: 'front/v1/area/province',

          method: 'get'
        })
        .then(res => {
          this.provinces = res.data;
        });
    },
    cancle() {
      this.showInterviewModal = false;
    }
  }
};
</script>

<style lang="less" scoped>
.jianli-container {
  min-height: 600px;
}
.list {
  .item {
    display: flex;
    align-items: center;
    height: 100px;
    margin-bottom: 1px;
    background: #fff;
    color: #363e4f;
    > img {
      width: 52px;
      height: 52px;
      margin-left: 40px;
    }
    .zhiwei {
      margin-left: 20px;
      flex: 1;
      .title {
        font-size: 18px;
        margin-bottom: 10px;
      }
    }
    .status {
      flex: 1;
      font-size: 14px;
    }
    .mianshi {
      color: #0491ff;
    }
    .weitongguo {
      color: #363e4f;
      opacity: 0.5;
    }
    .tongguo {
      color: #33c5d7;
    }
    .btns {
      display: flex;
      margin-right: 45px;
      font-size: 14px;
      position: relative;
      > .btn {
        padding: 15px;
        color: #d6000f;
        cursor: pointer;
      }
      .btnList {
        position: absolute;
        z-index: 1;
        top: 45px;
        left: -80px;
        width: 129px;
        background-color: #fff;
        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
        > div {
          height: 36px;
          text-align: center;
          line-height: 36px;
          cursor: pointer;
        }
        > div:hover {
          background: rgba(72, 146, 253, 0.1);
        }
      }
    }
  }
}
.action {
  margin-right: 10px;
}
</style>
